import * as types from "../../types";

export default function (state = {}, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_MY_USER:
            return {
                ...state,
                myuser: payload
            };
        default:
            return state;
    }
}